import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-employee-systems',
  templateUrl: './employee-systems.component.html',
  styleUrls: ['./employee-systems.component.scss']
})
export class EmployeeSystemsComponent implements OnInit {
  button={}
  customDataSource: any;
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

constructor( public Objects:ObjectsService,public _EmployeeService:EmployeeService,public router:Router,public gt:genericCustomStoreService) {
  // _EmployeeService.submit("Employee");    
  this.customDataSource = _EmployeeService.customDataSourceEmployee;  
  this.button=Objects.button;
  this.currentLang = localStorage.getItem(
    this.LOCALIZATION_LOCAL_STORAGE_KEY
  );
}
ngOnInit(): void {}

employeeForm(e:any){            
  this.router.navigate(['hr/EmployeeSystemsData']) 
  this._EmployeeService.$EMPLOYEE_ID.next(e.key?e.key:0)
}

onEditorPreparing(e:any) {
  this.gt.onEditorPreparing(e)
}
addrowfun(name:string){
  return this.gt.addrow(name)
}

}

